import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AllRepaymentSummaryPageUI from './AllRepaymentSummaryPageUI.js'

class AllRepaymentSummaryPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      totalPaid: null,
      totalUnpaid: null,
      checked: false,
      downloadSubmitted: null,
      view: false,
      priorPaidLoanRepaymentList: null,
      priorPrepaidLoanRepaymentList: null,
      priorDueLoanRepaymentList: null
    }
  }

  render() {
    return (
      <AllRepaymentSummaryPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        priorPaidLoanRepaymentList={this.state.priorPaidLoanRepaymentList}
        priorPrepaidLoanRepaymentList={this.state.priorPrepaidLoanRepaymentList}
        priorDueLoanRepaymentList={this.state.priorDueLoanRepaymentList}
        onRefreshClick={this.onRefreshClick}
        totalPaid={this.state.totalPaid}
        totalUnpaid={this.state.totalUnpaid}
        checked={this.state.checked}
        onShowDetailsChange={this.onShowDetailsChange}
        onDownloadClick={this.onDownloadClick}
        downloadSubmitted={this.state.downloadSubmitted}
        view={this.state.view}
        onViewChange={this.onViewChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getPaidRepayments(context)
    this.getUnPaidRepayments(context)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.year == prevProps.match.params.year &&
      this.props.match.params.month == prevProps.match.params.month
    )
      return
    let context = this.props.context
    this.setState({
      priorPaidLoanRepaymentList: null, priorDueLoanRepaymentList: null,
      errorList: null, totalPaid: null, totalUnpaid: null
    }, () => {
      this.getPaidRepayments(context)
      this.getUnPaidRepayments(context)
    })
  }

  getPaidRepayments(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/repayments/paidYearMonth`,
      cacheKey: CacheKeys.PaidRepayments(this.props.match.params.year, this.props.match.params.month),
      callback: this.getPaidRepaymentsCallback,
      ttlInSecs: 60
    })
    if (!this.props.match.params.year || !this.props.match.params.month)
      cacheManager.getObject2(context, {}, {})
    else
      cacheManager.getObject2(context, {}, {
        year: this.props.match.params.year,
        month: this.props.match.params.month,
      })
  }

  getPaidRepaymentsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      priorPaidLoanRepaymentList: response.priorPaidLoanRepaymentList,
      priorPrepaidLoanRepaymentList: response.priorPrepaidLoanRepaymentList,
      totalPaid: response
    })
  }

  getUnPaidRepayments(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/repayments/unpaidYearMonth`,
      cacheKey: CacheKeys.UnPaidRepayments(this.props.match.params.year, this.props.match.params.month),
      callback: this.getUnPaidRepaymentsCallback,
      ttlInSecs: 60
    })
    if (!this.props.match.params.year || !this.props.match.params.month)
      cacheManager.getObject2(context, {}, {})
    else
      cacheManager.getObject2(context, {}, {
        year: this.props.match.params.year,
        month: this.props.match.params.month,
      })
  }

  getUnPaidRepaymentsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      priorDueLoanRepaymentList: response.priorDueLoanRepaymentList,
      totalUnpaid: response
    })
  }

  onShowDetailsChange = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onViewChange = () => {
    let view2 = !this.state.view
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { view: view2 })
    this.setState({
      view: view2
    })
  }

  onDownloadClick = () => {
    this.setState({
      downloadErrorList: null,
      downloadSubmitted: true
    })
    let year = this.props.match.params.year || ''
    let month = this.props.match.params.month || ''
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/loans/repayments/excel/fileDownloadSignedUrl?year=${year}&month=${month}`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.AllRepayments(this.props.match.params.year, this.props.match.params.month))
    CacheManager.removeObject(CacheKeys.PaidRepayments(this.props.match.params.year, this.props.match.params.month))
    CacheManager.removeObject(CacheKeys.UnPaidRepayments(this.props.match.params.year, this.props.match.params.month))
    this.setState({
      priorPaidLoanRepaymentList: null, priorDueLoanRepaymentList: null,
      errorList: null, totalPaid: null, totalUnpaid: null
    }, () => {
      this.getPaidRepayments(this.props.context)
      this.getUnPaidRepayments(this.props.context)
    })
  }

}

export default withRouter(AllRepaymentSummaryPageSF)
